var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid app-content content header-content app-header"},[(_vm.$device.isDesktop)?_c('desktop-navigation'):_c('mobile-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }